/**
 * SUPERVISION — LES NOMS DES SALLES (21/10/2026), sans React : les modèles
 * purs (et leurs tests) l'importent directement ; `commun.tsx` le réexporte.
 */

/**
 * LES TROIS SALLES DU CLUB s'appellent ROOM 1, ROOM 2, ROOM 3 — et rien
 * d'autre (décision d'Hugo, 21/10/2026). Les anciens noms (Salon, Planète,
 * Club) ne s'affichent PLUS, ni le code nu de Sonde (R1, R2, R3). Sonde porte
 * encore les anciens libellés (« Salon (R1) ») : on les remplace à l'affichage.
 * Les noms d'équipements (SWT-003-SALON…) restent tels quels : ce sont des noms
 * d'appareils.
 */
export const SALLES_CLUB: Readonly<Record<string, { nom: string; ordre: number }>> = {
  R1: { nom: 'ROOM 1', ordre: 1 },
  R2: { nom: 'ROOM 2', ordre: 2 },
  R3: { nom: 'ROOM 3', ordre: 3 },
  'REGIE-R1': { nom: 'Régie ROOM 1', ordre: 4 },
}

/** Nom affiché d'une zone : « ROOM 1 » pour R1… ; sinon le libellé de Sonde, anciens noms remplacés. */
export function nomSalle(code: string | null | undefined, label?: string | null): string {
  const c = code ?? ''
  const club = SALLES_CLUB[c]
  if (club) return club.nom
  const l = renommerSalles(label ?? '').trim()
  return l || c || '—'
}

/** Tri des zones : ROOM 1, ROOM 2, ROOM 3 d'abord, puis les autres dans l'ordre de Sonde. */
export const ordreSalle = (code: string | null | undefined): number => SALLES_CLUB[code ?? '']?.ordre ?? 100

/**
 * Remplace les anciens noms de salle dans un texte de Sonde (titre d'alerte,
 * message_fr, explication) : « Salon (R1) » → « ROOM 1 », « du Salon » → « de
 * ROOM 1 », « (Club) » → « (ROOM 3) »… « Club » seul n'est remplacé que dans
 * ces formes sûres (« Live Club », « réseau du club » ne bougent pas). Les noms
 * d'équipements en majuscules (SWT-003-SALON) ne sont jamais touchés.
 */
export function renommerSalles(texte: string | null | undefined): string {
  if (!texte) return texte ?? ''
  return texte
    .replace(/\bSalon \(R1\)/g, 'ROOM 1').replace(/\bPlanète \(R2\)/g, 'ROOM 2').replace(/\bClub \(R3\)/g, 'ROOM 3')
    .replace(/\((?:Salon|R1)\)/g, '(ROOM 1)').replace(/\((?:Planète|R2)\)/g, '(ROOM 2)').replace(/\((?:Club|R3)\)/g, '(ROOM 3)')
    .replace(/\bdu Salon\b/g, 'de ROOM 1').replace(/\bdu Club\b(?! Live)/g, 'de ROOM 3')
    // Le code nu après « salle » (phrases d'« Actualiser », « Salle « R1 » introuvable ») ;
    // jamais un nom d'appareil (« R1 - BAR », « R1-BAR », « R1 – BAR »).
    .replace(/\b([Ss]alle) (« ?)?(REGIE-R1|R[123])(?![\w-]|\s[-–])/g, (_t, s: string, g: string | undefined, c: string) => `${s} ${g ?? ''}${SALLES_CLUB[c]!.nom}`)
    .replace(/(?<![-\w])Salon\b/g, 'ROOM 1').replace(/(?<![-\w])Planète\b/g, 'ROOM 2')
}
